export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || "",
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || "",
  namespace: import.meta.env.VITE_AUTH0_NAMESPACE || "",
  redirect_uri: window.location.origin,
  parkingAudience: import.meta.env.VITE_PARKING_AUTH0_AUDIENCE || "",
  managementAudience: import.meta.env.VITE_MANAGEMENT_AUTH0_AUDIENCE || "",
  parkingScope: "openid profile email gis:read gis:create gis:update gis:delete",
  clientAudiance: import.meta.env.VITE_CLIENTS_AUTH0_AUDIENCE || "",
  clientScope: "clients:read orders:read",
  managementScope: "users:read users:create users:update users:delete",
  useRefreshTokens: true,
};
